export const MOBILE_QUERY = window.matchMedia("(max-width: 61.999em)")
